// extracted by mini-css-extract-plugin
export default {"back-btn":"Screen2_back-btn__2qUd-","card-wrapper":"Screen2_card-wrapper__GD74M","card":"Screen2_card__WkO0C","cross-img":"Screen2_cross-img__sPDH3","letter":"Screen2_letter__uLv2C"};